// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6f1d1f74","732":"91b9ba44","977":"8eb6c48f"}[chunkId] + ".chunk.js";
};